import React from "react";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";

import "./StatActivity.scss";
import { Locale } from "../../../../../assets/Locale";

import { Block } from "@randajan/jet-react/dom/block";
import { getStatField } from "../../../../../../arc/game/showStats";

const activityItems = [
    { id:"livedMs", Icon:AccessTimeOutlinedIcon },
    { id:"talkedMs", Icon:ForumOutlinedIcon }
];

export const StatActivity = (props)=>{
    const { stats } = props;
    const say = Locale.use();

    return (
        <Block className="StatActivity" caption={say("profileStatsSectionActivity")}>
            <div className="activityItems">
                {activityItems.map(item=>{
                    const field = getStatField(item.id, stats, say);
                    const Icon = item.Icon;

                    return (
                        <div className="activityItem" key={item.id}>
                            <Icon className="activityIcon" />
                            <span className="activityLabel">{field?.label}</span>
                            <span className="activityValue">{field?.value}</span>
                        </div>
                    );
                })}
            </div>
        </Block>
    );
};
